export enum TemplateStatus {
  DOES_NOT_EXIST = "DOES NOT EXIST",
  EDITABLE = "EDITABLE",
  LOCKED = "LOCKED",
}
